import { gql } from "@apollo/client"

const GET_PREVIEW_NOTIFICATION_EMAIL = gql`
  query($input: PreviewNotificationEmailInput!) {
    previewNotificationEmail(input: $input) {
      html
      text
    }
  }
`

export { GET_PREVIEW_NOTIFICATION_EMAIL }
